import type { ReactNode } from "react";
import {
  useTheme,
  type ResolvedTheme,
  type ThemeBackgrounds,
} from "./useTheme";
import { ThemeContext } from "./ThemeContext";

interface ThemeProviderProps {
  children: ReactNode;
  storageKey: string;
  backgrounds?: ThemeBackgrounds | undefined;
  forceTheme?: ResolvedTheme | undefined;
}

export function ThemeProvider({
  children,
  storageKey,
  backgrounds,
  forceTheme,
}: ThemeProviderProps) {
  const value = useTheme({ storageKey, backgrounds, forceTheme });
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}
